<template>
  <el-pagination style="margin:18px 0; text-align: right" background layout="total, prev, pager, next, sizes, slot"
    :page-sizes="[10, 15, 20, 30]"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page.sync="current"
    :pager-count="5"
    :total="totalCount">
    <span style="font-size: 13px; font-weight: 400;">共 {{Math.ceil(parseFloat(totalCount || 0) / pageSize)}} 页</span>
  </el-pagination>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.current = this.currentPage
    this.totalCount = this.total
  },
  data () {
    return {
      current: this.currentPage,
      totalCount: this.total,
      pageSize: 10
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler (val) {
        this.current = val;
      }
    },
    total: {
      immediate: true,
      handler (val) {
        this.totalCount = val;
      }
    }
  },
  methods: {
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.$emit('sizeChange', pageSize);
    },
    handleCurrentChange(pageNo) {
      this.$emit('currentChange', pageNo);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/business/Pageination.vue